<template>
  <div
    ref="keyframeElement"
    class="border-primary-600 absolute top-1/2 z-30 h-0 w-0 origin-bottom-left -translate-y-3 rotate-45 border-[5px]"
    :class="{
      'cursor-grabbing border-[6px]': isDragging,
      'cursor-grab hover:border-[5.5px]': !isDragging,
    }"
    @mousedown="startDrag"></div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  keyframe: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  pixelsPerSecond: {
    type: Number,
    required: true,
  },
  layerId: {
    type: String,
    required: true,
  },
  locked: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update-time']);

const keyframeElement = ref(null);
const isDragging = ref(false);
const dragStartX = ref(0);
const initialTime = ref(0);

const startDrag = (event) => {
  if (props.locked) return;
  event.preventDefault();
  event.stopPropagation();

  isDragging.value = true;
  dragStartX.value = event.clientX;
  initialTime.value = props.keyframe.time;

  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', stopDrag);
};

const onDrag = (event) => {
  if (!isDragging.value) return;

  const deltaX = event.clientX - dragStartX.value;
  const deltaTime = deltaX / props.pixelsPerSecond;
  const newTime = Math.max(0, initialTime.value + deltaTime);

  // Round to reasonable precision to avoid floating point issues
  const roundedTime = Math.round(newTime * 100) / 100;

  // Use fallback identifier if keyframe doesn't have an ID
  const keyframeId = props.keyframe.id || `${props.layerId}-${props.keyframe.time}`;

  emit('update-time', {
    layerId: props.layerId,
    keyframe: props.keyframe,
    newTime: roundedTime,
    index: props.index,
    isDragging: true,
  });
};

const stopDrag = (event) => {
  if (isDragging.value) {
    const deltaX = event.clientX - dragStartX.value;
    const deltaTime = deltaX / props.pixelsPerSecond;
    const newTime = Math.max(0, initialTime.value + deltaTime);
    const roundedTime = Math.round(newTime * 100) / 100;

    // Emit final position with isDragging: false
    emit('update-time', {
      layerId: props.layerId,
      keyframe: props.keyframe,
      newTime: roundedTime,
      index: props.index,
      isDragging: false,
    });
  }

  isDragging.value = false;

  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', stopDrag);
};
</script>
